import React from 'react';
import { ProfileBar } from '../../components/ProfileBar';
import { useTabSettings } from '../../hooks';

import './styles.scss';
import ExternalAuthProvider from './context/ExternalAuthProvider';
import { ExternalProvider } from '../../../lib';
interface PatientDetailsContentLayoutProps {
  isLoading?: boolean;
  children: React.ReactNode;
}
const PatientDetailsContentLayout = ({
  children,
  isLoading = false,
}: PatientDetailsContentLayoutProps) => {
  const { shouldDisplayLeftNavbar } = useTabSettings();
  return (
    <div
      className={`flexVert offsetNavbar patient-details-layout ${shouldDisplayLeftNavbar ? 'offsetNavbarLeft' : ''}`}
      style={{
        overflowX: 'hidden',
      }}
    >
      <ExternalAuthProvider provider={ExternalProvider.WITHINGS}>
        <ProfileBar isLoading={isLoading} />
        {children}
      </ExternalAuthProvider>
    </div>
  );
};

export default PatientDetailsContentLayout;
